import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { STATUSES } from '../config/constants';
import { authRef } from '../config/firebase';
import { network, contracts } from '../config/blockchain';
import { fetchGameUser, fetchGameBat, setGameBat, deleteGameBat, fetchTermsAgreed, setTermsAgreed } from '../redux/actions/firebaseActions';
import { fetchMyItems } from '../redux/actions/myItemsActions';
import Log from '../utils/Log';

export const withSell = (WrappedComponent) => {
  class Sell extends PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        showLogin: false,
        showTerms: false,
        termsCallback: null,
        showSupportedBrowsers: false,
        showDownloadMetaMask: false,
        showUnlockMetaMask: false,
        events: []
      };
    }

    componentWillMount() {
      authRef.onAuthStateChanged((user) => {
        if (user) {
          this.props.fetchGameBat(authRef.currentUser.uid);
        }
      });

      if (this.props.myWalletAddress) {
        this.props.fetchMyItems(this.props.myWalletAddress);
      }

      this.props.fetchGameUser();
      this.watchEvents();
    }

    componentWillUnmount() {
      if (this.state.events.length) {
        this.setState({
          events: this.state.events.filter((marketEvent) => {
            try {
              marketEvent.stopWatching((error, result) => {});
            }
            catch (e) {
              Log.error(`Error in marketEvent.stopWatching: ${e}`);
            }

            return false;
          })
        });
      }
    }

    componentDidUpdate(prevProps) {
      if (prevProps.myWalletAddress !== this.props.myWalletAddress) {
        this.props.fetchMyItems(this.props.myWalletAddress);
      }

      this.watchEvents();
    }

    watchEvents() {
      if ((this.props.status !== STATUSES.FALLBACK || network.fallbackAllowsWatchEvents) &&
        this.props.status !== STATUSES.UNKNOWN &&
        !this.state.events.length &&
        this.props.myWalletAddress) {

        const auctionBoughtFilter = contracts.stickItemTypeAuction.AuctionBought({buyer: this.props.myWalletAddress});
        auctionBoughtFilter.watch((error, result) => {
          if (!error) {
            Log.info('AuctionBought event triggered.');

            this.props.fetchMyItems(this.props.myWalletAddress);
          } else {
            Log.error(error);
          }
        });

        const saleBoughtFilter = contracts.stickItemTypeSale.SaleBought({buyer: this.props.myWalletAddress});
        saleBoughtFilter.watch((error, result) => {
          if (!error) {
            Log.info('SaleBought event triggered:');

            this.props.fetchMyItems(this.props.myWalletAddress);
          } else {
            Log.error(error);
          }
        });

        this.setState({
          events: [
            auctionBoughtFilter,
            saleBoughtFilter,
          ]
        });
      }
    }

    showLogin() {
      this.setState({
        showLogin: true
      });
    }

    hideLogin() {
      this.setState({
        showLogin: false
      });
    }

    showTerms(callback) {
      this.setState({
        showTerms: true,
        termsCallback: callback
      });
    }

    hideTerms() {
      this.setState({
        showTerms: false
      });
    }

    setTermsAgreed(agree) {
      window.localStorage.setItem('termsAgreed', true);

      if (this.props.gameUser) {
        this.props.setTermsAgreed(authRef.currentUser.uid, agree);
      }

      this.state.termsCallback();
    }

    setGameBat(myItem) {
      const superLeagueId = parseInt(myItem.schema.properties.superLeagueId.description, 10);
      const itemName = myItem.schema.properties.name.description;
      const typeId = myItem.schema.properties.typeId.description;

      const termsCallback = () => {
        this.setGameBat(myItem);
      };

      if (this.props.gameUser) {
        this.props.fetchTermsAgreed(authRef.currentUser.uid).then((termsAgreed) => {
          if (!termsAgreed) {
            const termsAgreedLocal = window.localStorage.getItem('termsAgreed');

            if (termsAgreedLocal) {
              this.props.setTermsAgreed(authRef.currentUser.uid, true);

              this.props.setGameBat(
                authRef.currentUser.uid,
                this.props.myWalletAddress,
                myItem.id,
                itemName,
                typeId,
                superLeagueId
              );
            } else {
              this.showTerms(termsCallback);
            }
          } else {
            this.props.setGameBat(
              authRef.currentUser.uid,
              this.props.myWalletAddress,
              myItem.id,
              itemName,
              typeId,
              superLeagueId
            );
          }
        });
      } else {
        const unregisterAuthObserver = authRef.onAuthStateChanged((user) => {
          if (user) {
            this.hideLogin();
            this.props.fetchTermsAgreed(authRef.currentUser.uid).then((termsAgreed) => {
              if (!termsAgreed) {
                const termsAgreedLocal = window.localStorage.getItem('termsAgreed');

                if (termsAgreedLocal) {
                  this.props.setTermsAgreed(authRef.currentUser.uid, true);

                  this.props.setGameBat(
                    authRef.currentUser.uid,
                    this.props.myWalletAddress,
                    myItem.id,
                    itemName,
                    typeId,
                    superLeagueId
                  );
                } else {
                  this.showTerms(termsCallback);
                }
              }
            });

            unregisterAuthObserver();
          }
        });

        this.showLogin();
      }
    }

    deleteGameBat() {
      if (this.props.gameUser) {
        this.props.deleteGameBat(authRef.currentUser.uid);
      }
    }

    // sellMyItem(myItem) {
    //   const price = prompt(`Enter the price in tokens for bat no# ${myItem.id}`, 1);
    //
    //   Log.info(`Price: ${price}.`);
    //
    //   if (price <= 0) {
    //     alert('Please enter a price higher than 0.');
    //     return;
    //   }
    //
    //   const realPriceInWei = price * this.props.web3.toWei(1, 'ether');
    //
    //   if (!this.props.myWalletAddress) {
    //     Log.error('User account not found.');
    //     return;
    //   }
    //
    //   Log.info(`sellBat id: ${myItem.id} - address: ${this.props.myWalletAddress}.`);
    //
    //   hasGasForContract(contracts.stickItems, this.props.myWalletAddress, this.props.web3).then((gas) => {
    //     contracts.stickItems.setApprovalForAll(contracts.stickItemsSale.address, true, {
    //       from: this.props.myWalletAddress,
    //       gas: gas
    //     }, (error, result) => {
    //       if (error) {
    //         Log.error(`Failed when tried to buy bat: ${error}.`);
    //         return;
    //       }
    //
    //       Log.info('Approved!');
    //
    //       // Delay the second request to give time to MetaMask to handle properly
    //       setTimeout(() => {
    //         hasGasForContract(contracts.stickItemsSale, this.props.myWalletAddress, this.props.web3).then((gas) => {
    //           contracts.stickItemsSale.createSale(
    //             myItem.id,
    //             realPriceInWei, {
    //               from: this.props.myWalletAddress,
    //               gas: gas
    //             },
    //             (error, result) => {
    //               if (error) {
    //                 Log.error(`Failed when tried to put bat to sale: ${error}.`);
    //                 return;
    //               }
    //
    //               Log.info('Bat sale transaction started on blockchain. The page will refresh when it completes.');
    //
    //               if (this.props.gameUser) {
    //                 this.props.deleteGameBat(authRef.currentUser.uid, myItem.id);
    //               }
    //             });
    //         }, (error) => {
    //           Log.error(error);
    //         });
    //       }, 500); // TODO Antipattern
    //     });
    //   }, (error) => {
    //     Log.error(error);
    //   });
    // }

    render() {
      return (
        <WrappedComponent
          showLogin={this.state.showLogin}
          hideLogin={this.hideLogin.bind(this)}
          showTerms={this.state.showTerms}
          hideTerms={this.hideTerms.bind(this)}
          setTermsAgreed={this.setTermsAgreed.bind(this)}
          myItems={this.props.myItems}
          gameUser={this.props.gameUser}
          gameBat={this.props.gameBat}
          setGameBat={this.setGameBat.bind(this)}
          deleteGameBat={this.deleteGameBat.bind(this)}/>
      );
    }
  }

  const mapStateToProps = state => {
    return {
      web3: state.web3Reducer.web3,
      status: state.web3Reducer.status,
      myWalletAddress: state.web3Reducer.myWalletAddress,
      myItems: state.myItemsReducer.myItems,
      gameUser: state.firebaseReducer.gameUser,
      gameBat: state.firebaseReducer.gameBat
    }
  }

  const mapDispatchToProps = {
    fetchMyItems,
    fetchGameUser,
    fetchGameBat,
    setGameBat,
    deleteGameBat,
    fetchTermsAgreed,
    setTermsAgreed
  }

  return connect(mapStateToProps, mapDispatchToProps)(Sell);
}

export default withSell;



// WEBPACK FOOTER //
// ./src/components/withSell.js